import styled from 'styled-components';

export const PropertiesSelectTableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;

  .checkbox {
    margin: 0;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;
  }
`;
